import gql from 'graphql-tag';

export const CREATE_RENTAL_ITEM = gql`
  mutation createRentalItems(
    $photo: Upload!
    $rentalItems: RentalItemsInput!
    $addOns: [AddOnInput]
    $businessOwnerId: Int
  ) {
    createRentalItems(
      photo: $photo
      businessOwnerId: $businessOwnerId
      rentalItems: $rentalItems
      addOns: $addOns
    ) {
      id
    }
  }
`;

export const UPDATE_RENTAL_ITEM = gql`
  mutation updateRentalItems(
    $photo: Upload
    $businessOwnerId: Int
    $rentalItems: RentalItemsInput
    $addOns: [AddOnInput]
    $deletedAddOns: [Int]
  ) {
    updateRentalItems(
      photo: $photo
      businessOwnerId: $businessOwnerId
      rentalItems: $rentalItems
      addOns: $addOns
      deletedAddOns: $deletedAddOns
    ) {
      rentalItems {
        id
      }
    }
  }
`;

export const DELETE_RENTAL_ITEMS = gql`
  mutation deleteRentalItems($id: Int!) {
    deleteRentalItems(id: $id) {
      id
    }
  }
`;